module.exports = __webpack_public_path__ + "static/img/logo.ba93ed20.png";